module.exports = __webpack_public_path__ + "static/media/carousel8.309239a3.jpeg";